module.exports = require("./nb-SJ.d.ts");